<template>
	<div class="shop_index">
		<!-- 公共头部 -->
		<div class="per-line-40 black top-box">
			<div class="fl">歡迎來到香港中國企業協會</div>
			<div class="fr">
				<span v-if="$store.state.userName === ''">未登錄</span>
				<span v-else>歡迎 <span class="blue">{{ $store.state.userName }}</span> <span @click="exitAccount()" class="c">退出</span></span>
				<span class="c mar-lef-15" @click="goArticleDetail(2)">關於我們</span>
				<span @click="goArticleDetail(3)" class="mar-lef-15 c">聯系我們</span>
			</div>
		</div>
		<div class="pos-relative" style="height: 272px;">
			<img src="static/img/banner1.jpg" class="banner-box" height="272" style="opacity: 0.4; ">
			<div class="pos-absolute" style="width: 500px; left: 10%; top: 45px;">
				<img src="static/img/logo.png" class="pos-absolute banner-box-logo width-100per">
			</div>
			<!-- 导航栏 -->
			<div class="per-line-50 red-b pos-absolute font-size-16 white width-100per" style="bottom: 10px;">
				<div style="width: 1200px; margin: 0 auto; " class="over-hidden">
					<div class="fl per-line-50 ellip tl c white" @click="goShopIndex()">首頁</div>
					<mu-menu class="fl per-line-50 tl c over-hidden white" style=" margin-left: 50px;" placement="bottom-start" open-on-hover :key='i' v-for="(category, i) in categorys">
						<div style="background-color: transparent;" class="fl per-line-50 ellip tl c white">{{ category.title }}</div>
						<mu-list slot="content" class="red-b white" :key='j' v-for="(categoryChild, j) in category.child">
							<mu-list-item button @click="goSortIndex(categoryChild.id, categoryChild.title)">
								<mu-list-item-title class="white">{{ categoryChild.title }}</mu-list-item-title>
							</mu-list-item>
						</mu-list>
					</mu-menu>
				</div>
			</div>
		</div>
		<!-- 公共头部 -->

		<!-- 最大的缩小 -->
		<div class="over-hidden top-box">
			<!-- 最外层左边一栏 -->
			<div class="fl" style="width: 880px;">
				<!-- 轮播图 -->
				<div class="pos-relative width-100per mar-top-15">
					<swiper :options="swiperOption">
						<swiper-slide :key='i' v-show="swiperImg.is_show" v-for="(swiperImg, i) in swiperImgs">
							<img @click="goAdPage(swiperImg.weburl)" class="c" :src="swiperImg.url | http" />
							<div>{{ swiperImg.title }}</div>
						</swiper-slide>
						<div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
						<div class="swiper-button-next swiper-button-black" slot="button-next"></div>
					</swiper>
				</div>
				<!-- 主页模块 -->
				<div class="per-big-cell tl mar-top-15" v-show="category.id !== 155 && category.id !== 160" v-for="category in categorys">
					<div class="font-size-18 pad-lef-15 pad-rig-15 c white mar-top-10 orange-b per-line-40 ellip" @click="goSortIndex(category.id, category.title)"><span class="fl">{{ category.title }}</span><span class="fr c font-size-14" >更多</span></div>
					<div class="per-little-cell white-b over-hidden">
						<div class="pad-lef-15 pad-rig-15 pad-top-5 pad-bot-5 over-hidden">
							<div class="per-line-30 ellip c over-hidden" :a="article.p_cate_id" :b="category.id" v-for="article in articles" @click="goArticleDetail(article.id)" v-show="article.p_cate_id === category.id">
								<div class="fl width-70per ellip tl">{{ article.title }}</div>
								<div class="fr width-30per ellip tr">{{ article.showtime | moment('YYYY-MM-DD') }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 右边一栏 全部写好了 -->
			<div class="fl tl mar-top-15 per-line-30" style="width: 300px; margin-left: 20px; ">
				<input placeholder="請輸入文章標題關鍵字" v-model="keyword" class="fl input-cus" type="text" style="width: 200px; padding-left: 10px; padding-right: 10px; height: 30px; border: 1px solid #90333c; ">
				<span style="width: 100px;" @click="hasKeyWord(keyword)" class="fl red-b white tc c">搜索</span>
			</div>
			<div class="fl mar-top-15" style="width: 300px; margin-left: 20px; ">
				
				<!-- 会员登录和注册 写好了 -->
				<transition name="slideDown">
					<div v-show='canShowRegister'>
						<div class="per-little-cell white-b" v-show="showLoginBox">
							<div class="per-line-30 mar-top-15 white orange-b tl pad-lef-15">會員註冊</div>
							<div class="white-b tl pad-lef-15 pad-rig-15 pad-top-15">
								<div class="per-line-30 ellip">
									<span class="width-30per">註冊類型</span>
									<select v-model="type" class="fr input-style width-70per">
										<option value="1">個人會員</option>
										<option value="2">企業會員</option>
										<option value="3">委員會</option>
									</select>
								</div>
								<div class="per-line-30 ellip mar-top-5">
									<span class="width-30per">用戶名</span>
									<input type="text" placeholder="用戶名" v-model="loginname" class="fr input-style width-70per">
								</div>
								<div class="per-line-30 ellip mar-top-5">
									<span class="width-30per">密碼</span>
									<input type="text" placeholder="密碼" v-model="password" class="fr input-style width-70per">
								</div>
								<div class="per-line-30 ellip mar-top-5">
									<span class="width-30per">確認密碼</span>
									<input type="text" placeholder="確認密碼" v-model="re_password" class="fr input-style width-70per">
								</div>
							</div>
							<div class="pad-bot-15 over-hidden mar-top-15 mar-lef-15">
								<div class="per-line-30 fl tc c red-b white" style="width: 100px; " @click="register()">註冊</div>
								<div class="per-line-30 fl tc c mar-lef-15" @click="jumpLoginOrRegister()">已有賬號?去登錄</div>
							</div>
						</div>
						<div class="per-little-cell white-b" style="height: 240px;" v-show="!showLoginBox">
							<div class="per-line-30 mar-top-15 white orange-b tl pad-lef-15">會員登錄</div>
							<div class="white-b tl pad-lef-15 pad-rig-15 pad-top-15 mar-top-30">
								<div class="per-line-30 ellip mar-top-5">
									<span class="width-30per">用戶名</span>
									<input type="text" placeholder="用戶名" v-model="loginname" class="fr input-style width-70per">
								</div>
								<div class="per-line-30 ellip mar-top-5">
									<span class="width-30per">密碼</span>
									<input type="text" placeholder="密碼" v-model="password" class="fr input-style width-70per">
								</div>
							</div>
							<div class="pad-bot-15 over-hidden mar-top-15 mar-lef-15">
								<div class="per-line-30 fl tc c red-b white" style="width: 100px; " @click="login()">登錄</div>
								<div class="per-line-30 fl tc c mar-lef-15" @click="jumpLoginOrRegister()">沒有賬號?去註冊</div>
							</div>
						</div>
					</div>
				</transition>
				<!-- 最新活动 写好了 -->
				<div class="per-little-cell">
					<div @click="goSortIndex(1, '最新活動')" class="per-line-30 white orange-b mar-top-15 tl pad-lef-15 pad-rig-15"><span class="fl">最新活動</span><span class="fr c font-size-14">更多</span></div>
					<div class="white-b tl">
						<div class="pad-lef-15 pad-rig-15 pad-top-5 pad-bot-5 over-hidden">
							<div class="per-line-30 ellip c" @click="goArticleDetail(newActivityList.id)" v-for="newActivityList in newActivityLists">
								{{ newActivityList.title }}
							</div>
						</div>
					</div>
				</div>
				<!-- 培训讲座 写好了 -->
				<div class="per-little-cell">
					<div @click="goSortIndex(2, '培訓講座')" class="per-line-30 white orange-b mar-top-15 pad-rig-15 tl pad-lef-15"><span class="fl">培訓講座</span><span class="fr c font-size-14">更多</span></div>
					<div class="white-b tl">
						<div class="pad-lef-15 pad-rig-15 pad-top-5 pad-bot-5 over-hidden">
							<div class="per-line-30 ellip c" @click="goArticleDetail(trainlecture.id)" v-for="trainlecture in trainlectures">
								{{ trainlecture.title }}
							</div>

						</div>
					</div>
				</div>
				<!-- 广告位 写好了 -->
				<div class="per-little-cell white-b" title="广告位" :class="{'mar-top-15': j === 0}" v-for="(ad, j) in ads">
					<div class="pad-5 white-b" style="width:50%; float:left;  padding:5px;" v-if="ad.id !=43">
						<img class="c width-100per" style="height: auto;" :src="ad.url | http" @click="goAdPage(ad.weburl)">
					</div>
					
				</div>
				<!-- 视频 音频位置-->
				<div class="per-little-cell" title="视频" :class="{'mar-top-15': j === 0}" v-for="(video, j) in videos">
					<div class="pad-15 white-b">
						<video :src="video.url | http" class="width-100per" controls="controls" @click="goAdPage(video.weburl)">
						</video>
					</div>
				</div>
				
				<div class="per-little-cell">
					<div class="per-line-30 white orange-b tl pad-lef-15">操作</div>
					<div class="white-b tl over-hidden">
						<div class="fl width-50per pad-15 tc c height-80" @click="check_ruhuizhinan()">
							<img src="static/img/calendar.png" width="20" height="20">
							<div>入會指南</div>
						</div>
						<div class="fl width-50per pad-15 tc c height-80" @click="showRegister()">
							<img src="static/img/schedule.png" width="20" height="20">
							<div>登錄/註冊</div>
						</div>
						<div class="fl width-50per pad-15 tc c height-80" @click="check_huiyuanzhongxin()">
							<img src="static/img/my.png" width="20" height="20">
							<div>會員中心</div>
						</div>
						<div class="fl width-50per pad-15 tc c height-80" @click="check_weiyuanhui()">
							<img src="static/img/my.png" width="20" height="20">
							<div>委員會入口</div>
						</div>
					</div>
				</div>
				<div class="per-little-cell white-b" title="广告位" :class="{'mar-top-15': j === 0}" v-for="(ad, j) in ads">
					
					<div class="pad-5 white-b" style="width:100%; float:left;  padding:5px;" v-if="ad.id ==43">
						<img class="c width-100per" style="height: auto;" :src="ad.url | http" @click="goAdPage(ad.weburl)">
					</div>
				</div>
				
			</div>
		</div>
		<!-- footer 内容 -->
		<div class="footer-box white-b over-hidden" style="margin: 50px auto 0; width: 1200px; ">
			<div class="fl tl font-size-12 pad-lef-15 pad-top-15 pad-bot-15" style="width: 880px; ">
				<div class="over-hidden">
					<div class="fl" style="width: 50px; ">友情鏈接</div>
					<div class="fl mar-lef-15" style="width: 800px; ">
						<span v-for="linkCateList in linkCateLists" class="fl font-xie blue under-line mar-rig-15 c" @click="goLinkIndex(linkCateList.id)">
							{{ linkCateList.title }}
						</span>
					</div>
				</div>
				<div class="over-hidden mar-top-5">
					<div class="fl">關於我們</div>
					<div class="mar-lef-15 fl global-box" v-html="downAbout"></div>
				</div>
				<div class="over-hidden mar-top-5">
					<span class="fl">聯系我們</span>
					<span class="mar-lef-15 fl global-box" v-html="downContact"></span>
					<span class="mar-lef-15 fl global-box" ></span>
				</div>
				<div class="over-hidden mar-top-5">
					<span class="fl">網絡贊助</span>
					 
					<span class="mar-lef-15 fl global-box" >中國聯通國際有限公司</span>
				</div>
				 
				<div class="over-hidden mar-top-5">
					<span>免責申明</span>
					<span class="mar-lef-15">版權告示</span>
				</div>
			</div>
			<div class="fl pad-top-15 pad-rig-15 pad-bot-15" style="margin-left: 20px; width: 300px; ">
				<img src="static/img/logo2.jpeg" width="100%">
			</div>
		</div>
		<!-- footer 内容 -->
	</div>
</template>
<script>
export default {
	name: 'shop_index',
	data () {
		return {
			categorys: [], // 所有分类
			articles: [], // 所有文章
			ads: [], // 所有广告
			linkCateLists: [], // 所有友情链接分类

			keyword: '', // 搜索关键字
			newActivityLists: [], // 最新活动
			trainlectures: [], // 培训讲座

			swiperImgs: [], // 所有轮播图
			swiperOption: {
				direction: 'horizontal',
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				autoplay: {
					delay: 2500,
					disableOnInteraction: false
				},
			},
			canShowRegister: false, // 是否显示登录页面
			showLoginBox: false, // 是否展示登录注册框
			
			// 登录注册用的
			loginname: '',
			password: '',
			re_password: '',
			type: 1,

			// 判断用户状态用的
			userType: '',
			isRuHui: '',
			hasQiYe: '',
			isShenHe: '',
			userId: '',
			userName: '',

			// 最下面的联系我们 关于我们
			downContact: '',
			downAbout: '',

			// 音频 视频
			videos: [],
		}
	},
	created () {
		let that = this

		// 从全局仓库获取
		this.userType = this.$store.state.userType
		this.isRuHui = this.$store.state.isRuHui
		this.hasQiYe = this.$store.state.hasQiYe
		this.isShenHe = this.$store.state.isShenHe
		this.userId = this.$store.state.user_id
		this.userName = this.$store.state.userName

		if (this.userName) {
			that.loginname = that.getLocalObj('xianggangzhongxie_user').loginname
			that.password = that.getLocalObj('xianggangzhongxie_user').password
			this.login(1)
		}
	},
	mounted () {
		let that = this

		// 获取音频视频
		that.c_ajax({cate_id: 1}, 'api.php/Ad/lists?visit=public', function (value) {
			if (value.data.status === 10001) {
				for (let v of value.data.lists) {
					that.videos.push(v)
				}
			}
		})
		// 获取轮播图
		that.c_ajax({cate_id: 3, }, 'api.php/Ad/lists?visit=public', function (value) {
			if (value.data.status === 10001) {
				for (let v of value.data.lists) {
					that.swiperImgs.push(v)
				}
			}
		})
		// 获取右边广告
		that.c_ajax({cate_id: 2}, 'api.php/Ad/lists?visit=public', function (value) {
			if (value.data.status === 10001) {
				for (let v of value.data.lists) {
					that.ads.push(v)
				}
			}
		})
		// 获取所有分类
		that.c_ajax({}, 'api.php/CmsCategory/lists?visit=public', function (value) {
			for (let v of value.data) {
				if (v.id !== 1 && v.id !== 2 && v.id !== 147) {
					that.categorys.push(v)
					let tempID = 0
					if (v.id === 173) {
						tempID = 174
					} else if (v.id === 164) {
						tempID = 166
					} else {
						tempID = v.id
					}

					that.c_ajax({cate_id: tempID, }, 'api.php/Cms/lists?visit=public&num=5&p=1', function (value) {
						if (value.data.status === 10001) {
							for (let vv of value.data.lists) {
								vv.p_cate_id = v.id
								that.articles.push(vv)
							}
						}
					})
				}
			}
		})
		// 获取培训讲座文章列表
		that.getArticleLists(2, function (v) {
			that.trainlectures.push(v)
		})
		// 获取最新活动文章列表
		that.getArticleLists(1, function (v) {
			that.newActivityLists.push(v)
		})
		// 获取友情链接
		that.c_ajax({}, 'api.php/Link/cate_lists?visit=public', function (value) {
			if (value.data.status === 10001) {
				for (let v of value.data.data) {
					that.linkCateLists.push(v)
				}
			}
		})
		// 获得联系我们
		that.c_ajax({id: 2, }, 'api.php/Cms/detail?visit=public', function (value) {
			if (value.data.status === 10001) {
				that.downContact = value.data.detail.context
			}
		})
		// 获得关于我们
		that.c_ajax({id: 3, }, 'api.php/Cms/detail?visit=public', function (value) {
			if (value.data.status === 10001) {
				that.downAbout = value.data.detail.context
			}
		})
	},
	methods: {
		check_ruhuizhinan () {
			if (!this.userId) {
				this.showDialog('請先登錄!')
				return
			}
			if (this.userType === 2) {
				if (this.isShenHe) {
					this.showDialog('您已有企業，無需再次新建!')
					return
				}
				if (this.hasQiYe) {
					this.showDialog('您已新建企業，等待管理員審核通過!')
					return
				}
				this.goBusCompleteInfo()
			} else if (this.userType === 1) {
				if (this.isShenHe) {
					this.showDialog('您已入會，無需再次申請!')
					return
				}
				if (this.isRuHui) {
					this.showDialog('您已申請入會，等待管理員審核通過!')
					return
				}
				this.goUserCompleteInfo()
			} else if (this.userType === 3) {
				this.showDialog('您是委員會用戶， 請從委員會入口進入!')
				return
			}
		},
		check_huiyuanzhongxin () {
			if (!this.userId) {
				this.showDialog('請先登錄!')
				return
			}
			if (this.userType === 2) {
				if (!this.hasQiYe) {
					this.showDialog('您還沒有新建企業!')
					return
				}
				if (!this.isShenHe) {
					this.showDialog('還在審核中!')
					return
				}
				this.goBusIndex()
			} else if (this.userType === 1) {
				if (!this.isRuHui) {
					this.showDialog('您還沒入會，請申請入會!')
					return
				}
				if (!this.isShenHe) {
					this.showDialog('還在審核中!')
					return
				}
				this.goUserIndex()
			} else if (this.userType === 3) {
				this.showDialog('您是委員會用戶， 請從委員會入口進入!')
				return
			}
		},
		check_weiyuanhui () {
			if (!this.userId) {
				this.showDialog('請先登錄!')
				return
			}
			if (this.userType !== 3) {
				this.showDialog('您不是委員會用戶， 無法進入!')
				return
			}
			if (!this.isShenHe) {
				this.showDialog('還在審核中!')
				return
			}
			this.goWeiyuanIndex()
		},
		// 获取文章列表
		getArticleLists (cate_id, callback) {
			let that = this
			that.c_ajax({cate_id: cate_id, }, 'api.php/Cms/lists?visit=public&num=3&p=1', function (value) {
				if (value.data.status === 10001) {
					for (let v of value.data.lists) {
						callback(v)
					}
				}
			})
		},
		// 显示和隐藏会员注册
		showRegister () {
			let that = this
			that.canShowRegister = !that.canShowRegister
		},
		// 注册
		register () {
			let that = this
			if (!this.loginname) {
				this.showDialog('請輸入會員名稱!')
				return
			}
			if (!this.password) {
				this.showDialog('密碼不能為空!')
				return
			}
			if (!this.re_password) {
				this.showDialog('請再次輸入密碼!')
				return
			}
			if (this.re_password !== this.password) {
				this.showDialog('密碼不壹致!')
				return
			}
			let post = {
				loginname: this.loginname,
				password: this.password,
				re_password: this.re_password,
				type: this.type,
			}
			that.c_ajax({post: post}, 'api.php/Reg/reg?visit=public', function (value) {
				if (value.data.status === 10001) {
					that.showDialog('註冊成功!')
					that.showLoginBox = !that.showLoginBox
				} else {
					that.showDialog(value.data.msg)
				}
			})
		},
		// 登录
		login (notDialog) {
			let that = this
			if (!this.loginname) {
				this.showDialog('請輸入會員名稱!')
				return
			}
			if (!this.password) {
				this.showDialog('密碼不能為空!')
				return
			}
			let post = {
				loginname: this.loginname,
				password: this.password,
			}

			that.setLocalObj('xianggangzhongxie_user', {
				loginname: that.loginname,
				password: that.password,
			})

			that.c_ajax({post: post}, 'api.php/Login/login?visit=public', function (value) {
				if (value.data.status === 10001) {
					if (!notDialog) {
						that.showDialog('登錄成功')
					}
					let locationDate = new Date().getTime()

					that.setLocalObj('xianggangzhongxie', {
						user_id: value.data.user_id,
						token: value.data.token,
						token_time: locationDate,
						userType: value.data.type,
						isShenHe: value.data.isShenHe,
						isRuHui: value.data.is_ruhui,
						hasQiYe: value.data.is_ruhui,
						userName: value.data.username,
					})

					that.$store.commit('updateUser', {
						user_id: that.getLocalObj('xianggangzhongxie').user_id,
						token: that.getLocalObj('xianggangzhongxie').token,
						token_time: that.getLocalObj('xianggangzhongxie').token_time,
						userName: that.getLocalObj('xianggangzhongxie').userName,
					})

					that.$store.commit('updateUserType', {
						userType: that.getLocalObj('xianggangzhongxie').userType,
					})
					that.$store.commit('updateIsShenHe', {
						isShenHe: that.getLocalObj('xianggangzhongxie').isShenHe,
					})
					that.$store.commit('updateIsRuHui', {
						isRuHui: that.getLocalObj('xianggangzhongxie').isRuHui,
					})
					that.$store.commit('updateHasQiYe', {
						hasQiYe: that.getLocalObj('xianggangzhongxie').hasQiYe,
					})

					that.isRuHui = that.$store.state.isRuHui
					that.hasQiYe = that.$store.state.hasQiYe
					that.isShenHe = that.$store.state.isShenHe
					that.userId = that.$store.state.user_id
					that.userName = that.$store.state.userName
					that.userType = that.$store.state.userType

					that.canShowRegister = false
					that.loginname = ''
					that.password = ''
					that.re_password = ''
				} else {
					that.showDialog(value.data.msg)
				}
			})
		},
		// 注册登录切换
		jumpLoginOrRegister () {
			this.loginname = ''
			this.password = ''
			this.re_password = ''
			this.showLoginBox = !this.showLoginBox
		},
		hasKeyWord (k) {
			if (k) {
				this.goSearchIndex(k)
			} else {
				this.showDialog('請輸入要搜索的內容!')
			}
		},
	},
}
</script>
<style scoped>
.shop_index {
	padding-bottom: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/shop_index.vue